import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=5a653550"
import script from "./AccountModal.vue?vue&type=script&lang=js"
export * from "./AccountModal.vue?vue&type=script&lang=js"
import style0 from "./AccountModal.vue?vue&type=style&index=0&id=5a653550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports